import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da4f3470"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-block" }
const _hoisted_2 = {
  key: 0,
  class: "title_green"
}
const _hoisted_3 = {
  key: 1,
  class: "title_green"
}
const _hoisted_4 = {
  key: 0,
  class: "profile-block-wrapper"
}
const _hoisted_5 = { class: "profile-block__element" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile-block__title" }, " Имя или телефон ", -1 /* HOISTED */))
const _hoisted_7 = { class: "profile-block__element" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile-block__title" }, " Созданные ", -1 /* HOISTED */))
const _hoisted_9 = { class: "profile-block__element" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile-block__title" }, " Наличие соц. сетей ", -1 /* HOISTED */))
const _hoisted_11 = { class: "options" }

import pSelect from '@/common/pSelect/pSelect.vue'
import pCheckbox from '@/common/pCheckbox/pCheckbox.vue'
import pInput from '@/common/pInput/pInput.vue'
import ArrowIcon from '@/common/icons/ArrowIcon.vue'
import ProfileTimes from "@/searchSection/types/ProfileTimes";
import { ref, Ref, computed, ComputedRef } from "vue";
import { useSearchStore } from "@/searchSection/store/searchStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileBlock',
  props: {
    visibleFiltersProfiles: { type: Boolean }
  },
  emits: ['toggleFilter'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const searchStore = useSearchStore()
const profileTimes: Ref<ProfileTimes> = ref({
  allTime: 'За все время',
  year: 'За последний год',
  month: 'За последний месяц',
  week: 'За последнюю неделю',
  days: 'За последние 2 дня',
})

const profileTimesDescription: ComputedRef<{ id: string | number; name: string }[]> = computed(() => {
  return Object.entries(profileTimes.value).map(([key, value]) => ({
    id: key,
    name: value
  }))
})

const withSocial: Ref = ref([
  {
    id: 'pass',
    name: 'Не важно',
  },
  {
    id: 'yes',
    name: 'Да',
  },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "profile-block__title title",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggleFilter')))
    }, [
      _createTextVNode(" Анкеты "),
      (_unref(searchStore).filtersProfiles)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Указаны " + _toDisplayString(_unref(searchStore).filtersProfiles) + " параметр ", 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, "Не указаны")),
      _createVNode(ArrowIcon, {
        class: _normalizeClass(["title__arrow", { 'title__arrow_active': _ctx.visibleFiltersProfiles }])
      }, null, 8 /* PROPS */, ["class"])
    ]),
    _createVNode(_Transition, { name: "fade-slide" }, {
      default: _withCtx(() => [
        (_ctx.visibleFiltersProfiles)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(pInput, {
                  class: "profile-block__input",
                  iconName: 'search',
                  outLabel: true,
                  value: _unref(searchStore).searchOptions.profileInfo.searchText,
                  placeholder: 'Введите имя или номер телефона',
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(searchStore).searchOptions.profileInfo.searchText = $event.target.value))
                }, null, 8 /* PROPS */, ["value"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(pSelect, {
                  class: "profile-block__input",
                  selectionItems: profileTimesDescription.value,
                  modelValue: _unref(searchStore).searchOptions.profileInfo.time,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchStore).searchOptions.profileInfo.time) = $event))
                }, null, 8 /* PROPS */, ["selectionItems", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(pSelect, {
                  class: "profile-block__input",
                  selectionItems: withSocial.value,
                  modelValue: _unref(searchStore).searchOptions.profileInfo.withSocial,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchStore).searchOptions.profileInfo.withSocial) = $event))
                }, null, 8 /* PROPS */, ["selectionItems", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(pCheckbox, {
                  modelValue: _unref(searchStore).searchOptions.profileInfo.verified,
                  label: 'Проверенные',
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_unref(searchStore).searchOptions.profileInfo.verified = !_unref(searchStore).searchOptions.profileInfo.verified))
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createVNode(pCheckbox, {
                  modelValue: _unref(searchStore).searchOptions.profileInfo.withVideo,
                  label: 'С видео',
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_unref(searchStore).searchOptions.profileInfo.withVideo = !_unref(searchStore).searchOptions.profileInfo.withVideo))
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createVNode(pCheckbox, {
                  modelValue: _unref(searchStore).searchOptions.profileInfo.withReviews,
                  label: 'С отзывами',
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_unref(searchStore).searchOptions.profileInfo.withReviews = !_unref(searchStore).searchOptions.profileInfo.withReviews))
                }, null, 8 /* PROPS */, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})